export default {
    name: 'Reports'
}
